module.exports = __webpack_public_path__ + "img/LogoHello.0c607905.jpg";